import { render, staticRenderFns } from "./TenantCenterTenantList.vue?vue&type=template&id=5e8da631&scoped=true&lang=pug"
import script from "./TenantCenterTenantList.vue?vue&type=script&lang=js"
export * from "./TenantCenterTenantList.vue?vue&type=script&lang=js"
import style0 from "./TenantCenterTenantList.vue?vue&type=style&index=0&id=5e8da631&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8da631",
  null
  
)

export default component.exports